// utils/validators.ts

export const validateEmail = (email: string): boolean => {
	const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	return emailRegex.test(email);
};

export const validatePhone = (phone: string): boolean => {
	const phoneRegex = /^\d{9}$/;
	return phoneRegex.test(phone);
};
